import { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Gate from './components/Gate';
import { Toaster } from './components/ui/sonner';

function App() {
  const [unlocked, setUnlocked] = useState(() => {
    try {
      return sessionStorage.getItem('blackaxe_unlocked') === '1';
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    document.title = 'BLACK AXE \u00B7 SOORI \u00B7 A Tamil Noir Feature';
  }, []);

  const handleUnlock = () => {
    try { sessionStorage.setItem('blackaxe_unlocked', '1'); } catch (_) {}
    setUnlocked(true);
  };

  return (
    <div className="App grain">
      {!unlocked && <Gate onUnlock={handleUnlock} />}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" />
    </div>
  );
}

export default App;
